import { css } from '@compiled/react';

import { SignupBackgroundLayout } from '@/components/signup/layouts/signup-background-layout';
import { ExistingUser } from '@/components/signup/site-activation/components/existing-user/existing-user';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { RovoDevAgentsLogo } from '@/components/signup/utils/logos/rovo-dev-agents-logo';

import { SignupFormWithPaymentSwitcher } from '../../components/payment/signup-form-with-payment-switcher';
import { PrivacyPolicy } from '../../components/privacy-policy';
import { WelcomeBackHeading } from '../../components/welcome-back-heading';

const headerCss = css({
	margin: 0,
	textAlign: 'center',
});

export const LoggedInRovoDevStandardExistingSitesUser = () => {
	return (
		<SignupBackgroundLayout theme="green" ProductLogo={<RovoDevAgentsLogo />}>
			<SiteActivation
				ExistingUser={
					<SignupFormWithPaymentSwitcher
						header={
							<h1 css={headerCss}>
								<WelcomeBackHeading />
							</h1>
						}
					>
						<ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
					</SignupFormWithPaymentSwitcher>
				}
				WeekOneUser={null}
				ManagedUser={null}
			/>
		</SignupBackgroundLayout>
	);
};
